import React from "react";
import { Gift, X } from "lucide-react";

export const BoxTray = ({ active, pickedProducts, onRemove, complete }) => (
  <div className="flex items-center gap-1.5 sm:gap-2" data-testid="bundle-box-tray">
    {Array.from({ length: active.qty }).map((_, i) => {
      const p = pickedProducts[i];
      return p ? (
        <button
          key={p.id}
          onClick={() => onRemove(p.id)}
          className="gg-tray-pop group relative w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden flex-shrink-0"
          style={{ boxShadow: `0 0 0 2px ${active.accent}, 0 6px 12px -6px rgba(74,44,53,0.5)` }}
          aria-label={`Remove ${p.name}`}
          data-testid={`bundle-tray-slot-${i}`}
        >
          <img src={p.image} alt="" className="w-full h-full object-cover" />
          <span className="absolute inset-0 bg-plum/55 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
            <X size={12} className="text-cream" />
          </span>
        </button>
      ) : (
        <span
          key={`empty-${i}`}
          className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex-shrink-0 flex items-center justify-center text-[10px] font-semibold text-plum/35"
          style={{ border: "1.5px dashed rgba(74,44,53,0.25)", background: "rgba(255,255,255,0.35)" }}
          data-testid={`bundle-tray-slot-${i}`}
        >
          {i + 1}
        </span>
      );
    })}
    {active.hasFreeGift && (
      <span
        className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex-shrink-0 flex items-center justify-center transition-[opacity,transform] ${
          complete ? "gg-gift-glow-static scale-105" : "opacity-45"
        }`}
        style={{ background: complete ? "linear-gradient(135deg,#F4D58D,#C5985A)" : "rgba(197,152,90,0.15)", border: "1.5px dashed rgba(197,152,90,0.6)" }}
        data-testid="bundle-tray-gift"
        title="Free gift"
      >
        <Gift size={14} className="text-plum" />
      </span>
    )}
  </div>
);

export default BoxTray;
